<mat-card class="px-4 w-100 mb-3">
  <mat-card-content class="h-100 d-flex flex-column">
    <mat-card-header class="w-100">
      <mat-card-title class="mt-2">
        <div class="text-lg-left text-center d-flex flex-column flex-lg-row justify-content-lg-between">
          <div class="d-flex pl-4 flex-column">
            <div>
              <span class="font-weight-bold">{{ title.split(' ')[0] }}</span>
              <span class="pl-1 light">{{ title.split(' ')[1] }}</span>
            </div>
            <div *ngIf="doofFeature && title === eOrderBarChartTitleType.WEEKLY" class="text-muted" style="font-size: 16px">Click on a week to see daily totals</div>
          </div>
          <div class="d-flex justify-content-center mt-2 mt-lg-0">
            <mat-button-toggle-group aria-label="Show percentage"
                                     (change)="togglePercentageFormat($event)"
                                     [value]="showPercentage">
              <mat-button-toggle [value]="false">Numbers</mat-button-toggle>
              <mat-button-toggle [value]="true">Percentages</mat-button-toggle>
            </mat-button-toggle-group>
          </div>
        </div>
      </mat-card-title>
    </mat-card-header>
    <div *ngIf="!isEmptyBarChart else noResults" class="d-flex align-items-end h-100">
      <div @fadeIn class="flex-fill w-100 h-100 chart-container" echarts [options]="config"
           (chartClick)="chartClicked($event)"></div>
    </div>
    <ng-template #noResults>
      <div class="h-100 d-flex align-items-center chart-container">
        <span class="w-100 text-center">No Results Found</span>
      </div>
    </ng-template>
  </mat-card-content>
</mat-card>
